import _ from 'lodash'

export default function (action, args) {
    console.log('cart-rule-action:cancel_click', { action, args })

    _.merge(args, { click: { cancel: true } })
}
